export default {
  state: {
    list: [],
    status: false
  },
  mutations: {
    SET_SYSTEM: (state, system) => {
      state.list = system
    },
    SET_STATUS: (state, status) => {
      state.status = status
    }
  },
  actions: {
    getSystem({ commit, state }) {
      return new Promise((resolve, reject) => {
        _api.home.getMyList().then(res => {
          if (res) {
            res.data.sort((a, b) => a.sort - b.sort)
            commit('SET_SYSTEM', res.data)
            commit('SET_STATUS', true)
            resolve()
          } else {
            reject(err)
          }
        })
      })
    }
  }
}
